<template>
  <div>
    <el-row style="margin-bottom:20px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-workmaster' }">工作通</el-breadcrumb-item>
        <el-breadcrumb-item>投标</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <div class="top">
      <div>
        <img src="@/assets/community/back.png" alt="" class="top-left-img" @click="back" />
      </div>
      <div>
        <img src="@/assets/work/toubiao.png" alt="" class="top-midlle-img" />
      </div>
      <div class="top-midlle-span">投标列表</div>
    </div>
    <div class="my_search">
      <el-input v-model="searchFormData.title" placeholder="请输入名称"></el-input>
      <el-button type="primary" style="margin-left: 20px;">搜索</el-button>
    </div>
    <div class="middle">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="title" label="标题">
        </el-table-column>
        <el-table-column prop="description" label="简介">
        </el-table-column>
        <el-table-column prop="mode" label="类型">
          <template slot-scope="{row}">
            <span v-if="row.mode == 1">招标</span>
            <span v-else-if="row.mode == 2" >帮忙</span>
          </template>
        </el-table-column>
        <el-table-column prop="commission" label="佣金">
        </el-table-column>
        <el-table-column prop="wrap_status" label="状态">
          <template slot-scope="{row}">
           
            <span v-if="row.wrap_status == 0" >待审核</span>
            <span v-if="row.wrap_status == 1" style="color: #1BD17E;">招标中</span>
            <span v-if="row.wrap_status == 2" style="color: #FF9004;">待选标</span>
            <span v-if="row.wrap_status == 3" style="color: #FF4E4E;">选标完成</span>
            <span v-if="row.wrap_status == 4" >已结束</span>
            
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" class-name="small-padding ">
          <template slot-scope="{row}">
            <el-button type="text" size="mini" @click="goDetail(row.crowd_id)">
              详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="text-align: right; padding: 20px">
      <!--分页-->
      <!--分页-->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="searchFormData.page" :page-size="searchFormData.limit" layout="total, prev, pager, next"
        :total="searchFormData.total">
      </el-pagination>
    </div>
  </div>
</template>
<script>

import { webCrowdIndexSearchList } from "@/api/director/package/index";


export default { 
  data() {
    return {
      searchLoading: false,
      searchFormData: {
        title: "",
        mode: "1",//1招标，2帮忙

        name: "",
        corpor_id: "",
        page: 1,
        limit: 10,
        total: 0,
      },
      tableData: [
      ],

    };
  },

  mounted() {
    console.log(this.$route.query.corpor_id)
    if (this.$route.query.corpor_id != "") {
      this.searchFormData.corpor_id = this.$route.query.corpor_id;
      this.fetchData();
      // 获取接口
    }

  },

  methods: {

    fetchData() {
      webCrowdIndexSearchList(this.searchFormData).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.tableData = res.data.data;
          this.searchFormData.total = res.data.total;
        } else {
          this.$message.error(res.msg ? res.msg : "请求错误");
        }
      });

    },

    // 当前页变更
    handleCurrentChange(num) {
      this.searchFormData.page = num;
      this.fetchData();
    },

    // 每页显示页面数变更
    handleSizeChange(size) {
      this.searchFormData.limit = size;
      this.fetchData();
    },

    back() {
      this.$router.go(-1);
    },

    formatDateTime(value) { // 时间戳转换日期格式方法
      if (value == null) {
        return ''
      } else {
        const date = new Date(value)
        const y = date.getFullYear() // 年
        let MM = date.getMonth() + 1 // 月
        MM = MM < 10 ? ('0' + MM) : MM
        let d = date.getDate() // 日
        d = d < 10 ? ('0' + d) : d
        let h = date.getHours() // 时
        h = h < 10 ? ('0' + h) : h
        let m = date.getMinutes()// 分
        m = m < 10 ? ('0' + m) : m
        let s = date.getSeconds()// 秒
        s = s < 10 ? ('0' + s) : s
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
      }
    },


    goDetail(crowd_id) {
      this.$router.push({ name: "tender-all-detail", query: { crowd_id: crowd_id,corpor_id:this.searchFormData.corpor_id } });

    }
  },


};
</script>

<style lang="scss" scoped>
.top {
  width: 950px;
  height: 31px;
  display: flex;
}

.top-left-img {
  margin-top: 8px;
  width: 25px;
  height: 25px;
}

.top-midlle-img {
  width: 40px;
  height: 40px;
}

.top-midlle-span {
  margin-left: 20px;
  margin-top: 8px;
  height: 16px;
  font-size: 16px;
  color: #181818;
  font-weight: bold;
}

.top-right {
  margin-top: 2px;
  margin-left: 740px;
}

.my_search {
  width: 400px;
  margin-top: 40px;
  display: flex;
}

.middle {
  width: 847px;
  margin-top: 50px;
  margin-left: 30px;
}

.middle-list {
  color: #4d71d9;
}

.bottom {
  float: right;
}

.dialog-up {
  height: 300px;
  display: flex;
}

.dialog-middle {
  width: 400px;
  margin-top: 30px;
  margin: 0 auto;
  margin-left: 70px;
}

.dialog-middle-right {
  margin-left: 20px;
}

.dialog-middle-right img {
  width: 83px;
  height: 83px;
}

.dialog-middle-frist {
  display: flex;
  flex-direction: column
}

.dialog-middle-sendoy {
  margin-top: 30px;
  display: flex;
  width: 350px;
  margin-bottom: 30px;
}

.dialog-middle-frist-up {
  color: #ACACAC;
}

.dialog-middle-frist-down {
  color: #181818;
  margin-top: 15px;
}

.dialog-middle-sendoy-left {
  display: flex;
  flex-direction: column;

}

.dialog-middle-sendoy-right {
  display: flex;
  flex-direction: column;
  margin-left: 190px;

}
</style>
